import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C2Text, C3Text } from "../../../common/components/text/CustomText";
import CircularProgressChart from "../../../common/components/chart/CircularProgressChart";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

export function DashboardTicketProgressCard({
    totalCount,
    completeCount,
    refundCount,
    equipmentCount,
    machineCount,
    repairCount,
    symptomCount,
}) {
    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"100%"}
            backgroundColor={"transparent"}
            justifyContent={"flex-start"}
            alignItem={"flex-start"}
            padding={"20px"}
        >
            <Column width={"100%"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                <C1Text>{Translate("gnb.ticket")}</C1Text>
                <Row justifyContent={"space-between"} width={"100%"} padding={"40px 0px 0px 0px"}>
                    <SizedBox width={"10px"} />
                    <CircularProgressChart
                        value={completeCount}
                        max={totalCount}
                        label={Translate("ticket.type.complete")}
                    />
                    <SizedBox width={"10px"} />
                    <Column justifyContent={"flex-start"} alignItem={"flex-start"} width={"45%"}>
                        <C2Text>{Translate("ticket.remainTicketType")}</C2Text>
                        <SizedBox height={"20px"} />
                        <Row justifyContent={"space-between"} width={"100%"}>
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.type.refund")}</C3Text>
                            <C2Text fontWeight={"600"}>{refundCount}</C2Text>
                        </Row>
                        <SizedBox height={"10px"} />
                        <Row justifyContent={"space-between"} width={"100%"}>
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.type.equipment")}</C3Text>
                            <C2Text fontWeight={"600"}>{equipmentCount}</C2Text>
                        </Row>
                        <SizedBox height={"10px"} />
                        <Row justifyContent={"space-between"} width={"100%"}>
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.type.machine")}</C3Text>
                            <C2Text fontWeight={"600"}>{machineCount}</C2Text>
                        </Row>
                        <SizedBox height={"10px"} />
                        <Row justifyContent={"space-between"} width={"100%"}>
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.type.repair")}</C3Text>
                            <C2Text fontWeight={"600"}>{repairCount}</C2Text>
                        </Row>
                        <SizedBox height={"10px"} />
                        <Row justifyContent={"space-between"} width={"100%"}>
                            <C3Text fontColor={Theme.color.gray500}>{Translate("ticket.type.symptoms")}</C3Text>
                            <C2Text fontWeight={"600"}>{symptomCount}</C2Text>
                        </Row>
                    </Column>
                    <SizedBox width={"10px"} />
                </Row>
            </Column>
        </SizedBox>
    );
}
